import moment from "moment";
import educationData from "../JSON/educationData.json";
import maritalStatusData from "../JSON/maritalStatusData.json";
import occupationData from "../JSON/occupationData.json";
import organizationTypeData from "../JSON/organizationTypeData.json";
import stateData from "../JSON/stateData.json";
import {
  getKeyByValueOfJson,
  getValueByKeyOfJson,
} from "../../Configs/Validator/FormValidations";
import { toJS } from "mobx";
import {
  getSHA256Hash,
  callMiddlewareAPI,
} from "../../Components/Common/CommonFunctions";
import { ApiName } from "@ipru-common/services/ApiEndpoints.js";

const CALCULATE_RETURN_URL = process.env.REACT_APP_CALCULATE_RETURN_PROD_URL;

const IP_URL = process.env.REACT_APP_IP_URL;

const LEAD_URL = process.env.REACT_APP_LEAD_URL;

const TRACER_URL = process.env.REACT_APP_TRACER_URL;
var checkloaded = false;
var RestoreDatLayer_Interval_Count = 0;

const calculateAPI = async (body) => {
  window.userInputRequestJSON = body;
  const reqParams = {
    method: "POST",
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
  };

  const response = await fetch(CALCULATE_RETURN_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      // console.info("Calculate Return :", result)
      return result;
    })
    .catch((error) => {
      // console.info("Error :", error)
      return error;
    });

  return response;
};

const ipAPI = async () => {
  const reqParams = {
    method: "GET",
  };

  const response = await fetch(IP_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      // console.info("IP Return :", result)
      return result;
    })
    .catch((error) => {
      // console.info("Error :", error)
      return error;
    });

  // console.info("IP Response :", response)
  return response;
};

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const leadWSAPI = async (FormStore, Suit_LMS12) => {
  var MAIN_URL = window.location.href;
  var URL_OBJ = new URL(MAIN_URL);
  var uidCode = URL_OBJ.searchParams.get("UID");
  // let JwtToken = await window.UserSession["JwtToken"]

  var glbUid =
    uidCode === null || uidCode === undefined || uidCode === "" ? 480 : uidCode;
  window.Glb_UID = glbUid;

  var ModalPremium = FormStore.quote_invest;
  ModalPremium = ModalPremium === "" ? "0" : ModalPremium;
  var AnnuityAmount = FormStore.quote_annuityAmount;
  AnnuityAmount = AnnuityAmount === "" ? "0" : AnnuityAmount;

  var PROD_CODE = FormStore.quote_formTab === "0" ? "I13" : "I14";
  var LMS_column_12 = "YES";
  if (typeof Suit_LMS12 === "boolean") {
    LMS_column_12 = Suit_LMS12 ? "YES" : "NO";
  } else {
    LMS_column_12 = FormStore.calc_checkOne ? "YES" : "NO";
  }
  var pageURL = new URL(window.location.href);
  var temp_obj = {
    lms_guaranteedcashbenefit: window.UserInput.IncomeBenefit,
    lms_nps_flag: window.UserInput.NPS_Flag,
    utm_campaign:
      pageURL.searchParams.get("utm_campaign") !== null
        ? pageURL.searchParams.get("utm_campaign")
        : "",

    utm_keyword:
      pageURL.searchParams.get("utm_term") !== null
        ? pageURL.searchParams.get("utm_term")
        : "",

    utm_adcontent:
      pageURL.searchParams.get("utm_content") !== null
        ? pageURL.searchParams.get("utm_content")
        : "",

    utm_source:
      pageURL.searchParams.get("utm_source") !== null
        ? pageURL.searchParams.get("utm_source")
        : "",
    pod_prsn_occptn: FormStore.calc_occupation,
    pad_add_city: FormStore.calc_city,
    gavisitorid: getCookie("_ga").split("GA1.2.")[1],
    pri_maritl_sts: FormStore.calc_marital.toLowerCase(),
    youth_express: window.UserInput.youth_express
      ? window.UserInput.youth_express
      : "ExistCust_No",
  };
  temp_obj = JSON.stringify(temp_obj);

  var personaType = URL_OBJ.searchParams.get("persona");
  const bodyLeadWS = {
    LMS_uid: glbUid,
    LMS_product_code: PROD_CODE,
    LMS_gender: FormStore.calc_gender,
    LMS_dob: FormStore.calc_dob,
    LMS_mobile: FormStore.calc_phone,
    LMS_email: FormStore.calc_email,
    LMS_product_specific: "google_search_q-,staff-No",
    keyword: "",
    matchtype: "",
    LMS_firstName: "",
    LMS_lastName: "",
    LMS_tobacco: "",
    LMS_sumassured: "0",
    LMS_policyTerm: window.UserInput["PolicyTerm"],
    LMS_policypaymentfrequency: FormStore.quote_annuityFreq,
    LMS_staff: window.UserInput.NPS_Flag,
    Lumpsum: "0",
    Monthly_income: "0",
    Term_critical_illness: "Self",
    // LMS_pageName: personaType === "GPPDA" ? "GPP DA- Annuity: GPP DA Calculator" : "GPP IA- Annuity: GPP IA Calculator",
    LMS_pageName:
      window.UserInput.productId === "I14"
        ? "GPP DA- Annuity: GPP DA Calculator"
        : "GPP IA- Annuity: GPP IA Calculator",
    LMS_pageURL: window.location.href.split("?")[0],
    LMS_session_id: "",
    LMS_typeofplan:
      FormStore.quote_NPS === "N" && FormStore.annuity === "DefferedAnnuity"
        ? "Me & Nominee"
        : FormStore.quote_Pension.split("_").join(" "),
    // LMS_typeofplan: window.UserInput["PensionFor"],
    LMS_column_1: "1",
    LMS_column_2: "",
    LMS_column_3: "", // AnnualIncome
    LMS_column_4: "",
    LMS_column_5: "",
    LMS_column_6: FormStore.calc_buyingFor,
    LMS_column_7: glbUid + "",
    LMS_column_8: "",
    LMS_column_9: "",
    LMS_column_10: "",
    LMS_column_11: FormStore.calc_checkTwo ? "YES" : "NO",
    LMS_column_12: LMS_column_12,
    LMS_TRAI_FLAG: FormStore.calc_checkOne ? "YES" : "NO",
    LMS_premium: ModalPremium,
    LMS_premiumterm: "", // NS
    LmsAdditionalDetails: JSON.stringify(temp_obj),
  };
  console.log("LeadWS", bodyLeadWS);
  const bodyLeadWSObj = new URLSearchParams();
  for (var i in bodyLeadWS) {
    bodyLeadWSObj.append(i, bodyLeadWS[i]);
  }

  // const reqParams = {
  //   method: "POST",
  //   body: JSON.stringify(bodyLeadWS),
  //   credentials: "include",
  //   mode: "cors",
  //   headers: {
  //     // "x-api-key": process.env.REACT_APP_LEAD_URL_X_API_KEY,
  //     // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  //     "Content-Type": "application/json",
  //     "Authorization": `Bearer ${JwtToken}`,
  //   },
  // }

  const isUat = false;

  const response = await callMiddlewareAPI(ApiName.LEADWS, bodyLeadWS)
    .then((result) => {
      console.info("Lead Return :", result);
      return result;
    })
    .catch((error) => {
      console.info("Lead Error :", error);
      return error;
    });
  window.fireConversion();
  // console.info("Lead Body :", body)
  // console.info("Lead Response :", response)
  return response;
};

const tracerAPI = async (FormStore, type) => {
  var MAIN_URL = window.location.href;
  var URL_OBJ = new URL(MAIN_URL);
  var uidCode = URL_OBJ.searchParams.get("UID");

  var glbUid =
    uidCode === null || uidCode === undefined || uidCode === "" ? 480 : uidCode;
  window.Glb_UID = glbUid;

  var dobVal = FormStore.calc_dob;
  var IP_ADD = window.ipAddress;
  var associationId = dobVal.split("/")[2] + FormStore.calc_phone.slice(3);
  associationId = type === 1 ? associationId : associationId + "" + IP_ADD;

  var ModalPremium = FormStore.quote_invest;
  ModalPremium = ModalPremium === "" ? "0" : ModalPremium;
  var AnnuityAmount = FormStore.quote_annuityAmount;
  AnnuityAmount = AnnuityAmount === "" ? "0" : AnnuityAmount;

  var PROD_CODE = FormStore.quote_formTab === "0" ? "I13" : "I14";

  const bodyTracerA = {
    message: "comition",
    properties: {
      amount: window.UserInput["lifeCover"],
      gender: FormStore.calc_gender,
      cardType: "ICICI BANK",
      mobileNo: FormStore.calc_phone,
      emailID: FormStore.calc_email,
      productCode: PROD_CODE,
      vendorUid: glbUid,
      associationId: associationId, // "19999999999", // "19999999999142.142.142.142"
      premium: ModalPremium,
      message:
        "www.icicilife.com/protection-saving-plans/icici-pru-gift-calculator.html",
      deviceId: "19 Jun 1989",
      ipAddress: IP_ADD,
    },
    source: process.env.REACT_APP_TRACER_URL_SOURCE,
  };

  const reqParams = {
    method: "POST",
    body: JSON.stringify(bodyTracerA),
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_LEAD_WS_X_API_KEY,
    },
  };

  const response = await callMiddlewareAPI(ApiName.TRACER, bodyTracerA)
    .then((result) => {
      // console.info("Tracer A Return :", result)
      return result;
    })
    .catch((error) => {
      // console.info("Tracer A Error :", error)
      return error;
    });

  // console.info("Tracer A Response :", response)
  return response;
};

const DataLayerFn = async (
  event,
  FormStore,
  question,
  button,
  options,
  extraFlag,
) => {
  var validDate = moment(FormStore.calc_dob, "DD/MM/YYYY").format("MM/YY");
  validDate = validDate === "Invalid date" ? "" : validDate;
  var validJointDOB = moment(FormStore.joint_DOB, "DD/MM/YYYY").format("MM/YY");
  validJointDOB = validJointDOB === "Invalid date" ? "" : validJointDOB;

  var quoteSeen = extraFlag["QuoteFlag"] || FormStore.quote_modal;
  quoteSeen =
    quoteSeen === undefined ? FormStore.quote_modalLoader : !quoteSeen;
  var SuitabilityCalculation = extraFlag["SuitabilityCalculation"] ?? "";
  var eventName = event.split("||")[0];
  var sectionName = event.split("||")[1];
  // console.info("DATALAYER FLAG :", PT)

  var PROD_CODE = FormStore.quote_formTab === "0" ? "I13" : "I14";

  const education =
    (await levelHandler("appform-details", "education")) !== ""
      ? await getValueByKeyOfJson(
          educationData,
          window.UserDataJSON["appform-details"]["education"],
        )
      : "";
  const maritalStatus =
    (await levelHandler("appform-details", "mrtlSts")) !== ""
      ? await getValueByKeyOfJson(
          maritalStatusData,
          window.UserDataJSON["appform-details"]["mrtlSts"],
        )
      : "";
  const occupation =
    (await levelHandler("appform-details", "occ")) !== ""
      ? await getValueByKeyOfJson(
          occupationData,
          window.UserDataJSON["appform-details"]["occ"],
        )
      : "";
  const organizationType =
    (await levelHandler("appform-details", "orgType")) !== ""
      ? await getValueByKeyOfJson(
          organizationTypeData,
          window.UserDataJSON["appform-details"]["orgType"],
        )
      : "";
  const state =
    (await levelHandler("Communication", "state")) !== ""
      ? await getKeyByValueOfJson(
          stateData,
          window.UserDataJSON["Communication"]["state"],
        )
      : "";

  var ApplicationNumber = await levelHandler("appNO", "");
  var OrganizationName = await levelHandler("appform-details", "orgNameDesc");
  var City = await levelHandler("Communication", "city");
  var NomineeRelationship = await levelHandler("Nominee", "relationship");
  var NomineeDOB = await levelHandler("Nominee", "nomineeDob");
  var ExistingCustomer = await levelHandler("ExistingCustomer", "");
  var GoalHorizon = await levelHandler("suitabilityMatrix", "goalHorizon");
  var InsurancePortfolioHeld = await levelHandler(
    "suitabilityMatrix",
    "insurancePortfolioHeld",
  );
  var RiskProfile = await levelHandler("suitabilityMatrix", "riskProfile");
  var phone = await getSHA256Hash(toJS(FormStore.calc_phone));
  var email = await getSHA256Hash(toJS(FormStore.calc_email));

  // console.info("FormStore.quote_formTab", FormStore.quote_formTab)
  var AnnuityAmount =
    FormStore.quote_annuityAmount === ""
      ? FormStore.api_value
      : FormStore.quote_annuityAmount;
  var annuity =
    FormStore.quote_formTab === "1" ? "DeferredAnnuity" : "ImmediateAnnuity";
  var isAppFormLoaded = window.isAppFormLoaded;
  var tempLayer = {
    event: eventName,
    ADBRValue: "",
    Age: FormStore.calc_age,
    AnnualIncome: "",
    AnnuityAmount: quoteSeen ? "" : AnnuityAmount,
    AnnuityFrequency: quoteSeen ? "" : FormStore.quote_annuityFreq,
    Button: button,
    CIValue: "",
    CancerCover: "",
    CarBrand: "",
    CarModel: "",
    CarVarient: "",
    City: !isAppFormLoaded ? "" : City,
    CoveredAge: "",
    // CoveredAge: quoteSeen ? "" : FormStore.annuity === "DeferredAnnuity" ? FormStore.calc_age + FormStore.quote_RecAnnuityFreq : FormStore.calc_age,
    DOB: validDate,
    Device: window.innerWidth > 768 ? "Desktop" : "Mobile", // Desktop / Mobile
    Education: !isAppFormLoaded ? "" : education,
    EstimatedReturnAt4: "",
    EstimatedReturnAt8: "",
    ExistingCustomer: !isAppFormLoaded ? "" : ExistingCustomer,
    Gender: FormStore.calc_gender,
    GroupEmployee: "",
    GuaranteedReturn: "",
    GoalHorizon: !isAppFormLoaded ? "" : GoalHorizon,
    InsurancePortfolioHeld: !isAppFormLoaded ? "" : InsurancePortfolioHeld,
    RiskProfile: !isAppFormLoaded ? "" : RiskProfile,
    OtherInsurancePolicy: "",
    HeartCover: "",
    HomeLoan: "",
    HospitalCashBenefit: "",
    IncomeBenefit: "",
    IncreasingCoverBenefit: "",
    InvestStyle: quoteSeen ? "" : "oneTime",
    LifeCoverSelected: quoteSeen ? "" : window.UserInput["lifeCover"],
    ApplicationNumber: !isAppFormLoaded ? "" : ApplicationNumber,
    MaritalStatus: !isAppFormLoaded ? "" : maritalStatus,
    MonthlyPremium: "",
    NPSSubscriber: FormStore.quote_NPS === "Y" ? "yes" : "no",
    NetworkUID1: quoteSeen
      ? ""
      : FormStore.calc_phone === ""
        ? ""
        : (phone ?? ""), // Mobile No Encrypted in SHA256
    NetworkUID2: quoteSeen
      ? ""
      : FormStore.calc_email === ""
        ? ""
        : (email ?? ""), // Email id Encrypted in SHA256
    NomineeDOB: !isAppFormLoaded
      ? ""
      : NomineeDOB !== ""
        ? moment(NomineeDOB, "DD/MM/YYYY").format("MM/YY")
        : "",
    Occupation: !isAppFormLoaded ? "" : occupation,
    OptionSelected:
      options !== "" ? options : (FormStore.quote_PlanSelectedObj.title ?? ""),
    OrganizationName: !isAppFormLoaded ? "" : OrganizationName,
    OrganizationType: !isAppFormLoaded ? "" : organizationType,
    OtherLoan: "",
    PaymentFrequency: "",
    PaymentTerm: quoteSeen
      ? ""
      : annuity === "DeferredAnnuity"
        ? FormStore.quote_RecAnnuityFreq
        : "",
    // PayoutTerm: quoteSeen ? "" : FormStore.annuity === "DeferredAnnuity" ? FormStore.quote_RecAnnuityFreq : "",
    PayoutOptionSelected: quoteSeen ? "" : annuity,
    PolicyHolder: quoteSeen ? "" : FormStore.quote_Pension,
    PolicyTerm: "",
    PolicyType: "",
    Premium: quoteSeen ? "" : FormStore.quote_invest,
    ProductCode: PROD_CODE,
    // ProductName: FormStore.quote_formTab === "0" ? "ICICI Pru GPP Immediate Annuity" : "ICICI Pru GPP Deferred Annuity",
    ProductName: "ICICI Pru Guaranteed Pension Plan",
    Question: question,
    Savings: "",
    SectionName: sectionName,
    State: !isAppFormLoaded ? "" : state,
    NomineeRelationship: !isAppFormLoaded ? "" : NomineeRelationship,

    Subchannel: "retirement-pension-plans",
    SuitabilityCalculation: SuitabilityCalculation,
    Tobacco: "",
    TypeOfOwnership: "",
    UID: window.Glb_UID,
    UserResponse: "",
    YearlyPremium: "",
    channel: "retirement",
    // event: eventName,
    jointlifeDOB: quoteSeen && FormStore.join_data_Show ? "" : validJointDOB,
    jointlifeRelationship: quoteSeen ? "" : FormStore.joint_life,
    nyPremium: "",
    pageName:
      window.UserInput.productId === "I14"
        ? "GPP DA- Annuity: GPP DA Calculator"
        : "GPP IA- Annuity: GPP IA Calculator",
    pageType: "mid-term: guaranteed-pension-plan-calculator",
    retirement: "",
    subsection1: "retirement-pension-plans",
    subsection2: "guaranteed-pension-plan-calculator",
  };

  console.info("DataLayer", tempLayer);
  checkloaded = window.dataLayer.find((item) => item.event === "gtm.load");
  if (!checkloaded) {
    window.tempDataLayer_BeforeCheckLoaded.push(tempLayer);
  } else {
    window.dataLayer.push(tempLayer);
  }
  return "";
};

var RestoreDatLayer_Interval = setInterval(() => {
  checkloaded = window.dataLayer.find((item) => item.event === "gtm.load");
  console.log("setinterval", checkloaded, RestoreDatLayer_Interval_Count);
  if (RestoreDatLayer_Interval_Count > 50 || checkloaded) {
    console.log("setinterval2", checkloaded, RestoreDatLayer_Interval_Count);
    window.dataLayer.push(...window.tempDataLayer_BeforeCheckLoaded);
    window.tempDataLayer_BeforeCheckLoaded = [];
    clearInterval(RestoreDatLayer_Interval);
  }
  RestoreDatLayer_Interval_Count++;
}, 500);

const levelHandler = async (lvl1, lvl2) => {
  try {
    if (lvl2 === "") return window.UserDataJSON[lvl1];
    else return window.UserDataJSON[lvl1][lvl2];
  } catch {
    return "";
  }
};

export { calculateAPI, ipAPI, leadWSAPI, tracerAPI, DataLayerFn };
